import {isNotNil} from 'ramda';

import {SalesLeagueCsvExport} from '@dms/api/sales';

/** The backend's own name already carries it; only the fallback has to add it. */
const CSV_EXTENSION = '.csv';

/**
 * Reached only when `Content-Disposition` does not survive to the browser, which would
 * otherwise leave the download unnamed. The backend's own name carries the period, branch
 * and closing date, so this is a floor and never the expected outcome.
 */
const FALLBACK_FILE_NAME = `sales-league-export${CSV_EXTENSION}`;

/**
 * Saves an exported board under the name the backend chose for it.
 *
 * Written out rather than delegated to `downloadBlobFile`, which takes a `Blob` — the export
 * arrives as an object URL precisely so no `Blob` reaches the Redux store. Revoking it here
 * is what keeps a file per click from accumulating for the life of the tab.
 */
export function downloadSalesLeagueCsv(csvExport: SalesLeagueCsvExport) {
  const link = document.createElement('a');

  link.href = csvExport.fileUrl;
  link.download = isNotNil(csvExport.fileName) ? csvExport.fileName : FALLBACK_FILE_NAME;

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(csvExport.fileUrl);
}
